module.exports = __webpack_public_path__ + "img/d4d.647eeebb.svg";